import { Injectable } from '@angular/core';


import { Auth } from 'src/providers/auth/auth';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';

@Injectable()
export class AlreadyAuthenticatedGuard  {

  constructor(
    private auth: Auth,
    private customNavController: CustomNavController
  ) {}

  canActivate(): boolean {
    if (this.auth.isAuthenticated()) {
      this.customNavController.navigateRoot(['dashboard']);
      return false;
    }

    return true;
  }

}
